import AdminMessagesPage from './AdminMessagesPage';

export default AdminMessagesPage;
